<template>
  <qx-card title="列表">
    <LogRightDialog ref="logRightDialog" busiCode="3000010" />

    <section slot="titleRight">
      <qx-permpisions permpisions="7000501">
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="vehicleServiceBO.ajax?cmd=doQueryInsuranceList"
          :params="fullSearchData"
          bizName="车辆保险记录信息导出"
          bizCode="exp100052"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>
      <qx-permpisions permpisions="7000502">
        <el-button type="primary" plain @click="() => toEdit(null, 'add')">
          <i class="iconfont">&#xe6ab;</i>新增
        </el-button>
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
          >
            <section slot-scope="scope">
              <section
                v-if="scope.column.property === 'plateNumber'"
                @click="toCarDetail(scope.row)"
              >
                <span class="primary cur">{{
                  scope.row[scope.column.property]
                }}</span>
              </section>
              <section v-else>
                <span>{{ scope.row[scope.column.property] }}</span>
              </section>
            </section>
          </el-table-column>

          <el-table-column
            prop="control"
            label="操作"
            fixed="right"
            width="180"
          >
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :maxLength="3"
                style="text-align: left"
                :btnList="[
                  {
                    name: '查看',
                    event: () => toEdit(scope.row, 'detail'),
                  },
                  {
                    permpisions: '7000503',
                    showCondition: scope.row.state !== 2,
                    name: '修改',
                    event: () => toEdit(scope.row, 'edit'),
                  },
                  {
                    permpisions: '7000505',
                    showCondition: scope.row.inDay > 0 && scope.row.state !== 2,
                    name: '终止',
                    event: () => toStop(scope.row),
                  },
                  {
                    name: '日志',
                    event: () => showLog(scope.row.id),
                  },
                  {
                    permpisions: '7000504',
                    name: '删除',
                    event: () => toDelete(scope.row),
                  }
                ]"
              />
            </template>
          </el-table-column>

          <!-- <el-table-column
            prop="control"
            label="操作"
            fixed="right"
            width="180"
          >
            <template slot-scope="scope">
              <section>
                <qx-permpisions
                  permpisions=""
                  v-for="(btnItem, btnIndex) in scope.row.ctrlBtnList"
                  :key="btnIndex"
                >
                  <span class="primary cur" @click="btnItem.event">{{
                    btnItem.name
                  }}</span>
                </qx-permpisions>

                <qx-permpisions
                  permpisions=""
                  v-if="scope.row.ctrlMoreBtnList.length"
                >
                  <el-dropdown>
                    <span class="el-dropdown-link cur primary">
                      <i class="iconfont">&#xe609;</i>
                    </span>
                    <el-dropdown-menu
                      slot="dropdown"
                      v-for="(btnItem, btnIndex) in scope.row.ctrlMoreBtnList"
                      :key="btnIndex"
                    >
                      <qx-permpisions>
                        <el-dropdown-item @click.native="btnItem.event">{{
                          btnItem.name
                        }}</el-dropdown-item>
                      </qx-permpisions>
                    </el-dropdown-menu>
                  </el-dropdown>
                </qx-permpisions>
              </section>
            </template>
          </el-table-column> -->
        </el-table>
      </section>
      <section class="paginationBox clearPa">
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
      </section>
    </section>
  </qx-card>
</template>
<script>
import tableMixin from '@qx/mixin/table';
import ExportBtn from 'components/exportBtn';
import LogRightDialog from 'components/logRightDialog';
import TableBtn from 'components/tableBtn/tableBtn';
import {
  doQueryInsuranceList,
  doDelete,
} from 'api/car';

export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
    LogRightDialog,
    TableBtn,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'plateNumber',
            label: '车牌号码',
          },
          {
            prop: 'licenceTypeName',
            label: '牌照类型',
          },
          {
            prop: 'vehicleInfo',
            label: '车型',
          },
          {
            prop: 'orgName',
            label: '归属部门',
          },
          {
            prop: 'relUserName',
            label: '归属员工',
          },
          {
            prop: 'linkman',
            label: '司机姓名',
          },
          {
            prop: 'mobilePhone',
            label: '司机手机',
          },
          {
            prop: 'certificatesInsuranceTypeName',
            label: '保险类型',
          },
          {
            prop: 'certificatesInsuranceFee',
            label: '金额',
          },
          {
            prop: 'insuranceStartDate',
            label: '生效时间',
          },
          {
            prop: 'insuranceEndDate',
            label: '到期时间',
          },
          {
            prop: 'inDay',
            label: '剩余天数',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: doQueryInsuranceList,
    toCarDetail (item) {
      if (item.licenceType < 3) {
        // 查看普通车辆详情
        const type = 'detail';
        this.jump({
          label: `查看车辆-${item.plateNumber}`,
          url: `/manage/car/archives/my/detailRecord?id=${item.vehicleCode}&vehicleClass=${item.vehicleClass || ''}&type=${type}`,
          full: true,
        });
      } else {
        // 查看挂车详情
        this.jump({
          label: `查看挂车-${item.plateNumber}`,
          url: `/manage/car/trailer/archives/detail?id=${item.vehicleCode}&type=${''}`,
          full: true,
        });
      }
    },
    async toDelete (item) {
      const confirmRes = await this.$confirm('确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
      });
      if (confirmRes === 'confirm') {
        const res = await doDelete({ id: item.id });
        if (!res.failed) {
          this.$message({
            type: 'success',
            message: '删除成功',
          });
          this.getData();
        }
      }
    },
    toStop (item) {
      this.jump({
        label: '终止车辆保险登记',
        url: `/manage/car/maintain/insurance/stop?id=${item.id}`,
        full: true,
      });
    },
    toEdit (item, type) {
      switch (type) {
        case 'add':
          this.jump({
            label: '新增保险登记',
            url: '/manage/car/maintain/insurance/edit',
            full: true,
          });
          break;
        case 'detail':
          this.jump({
            label: '查看保险登记',
            url: `/manage/car/maintain/insurance/detail?id=${item.id}&type=detail`,
            full: true,
          });
          break;
        case 'edit':
          if (item.hasApplyFee === 1) {
            this.$alert('已申请车辆费用，不能修改', '温馨提示', {
              confirmButtonText: '我知道了',
            });
            return;
          }
          this.jump({
            label: '修改保险登记',
            url: `/manage/car/maintain/insurance/edit?id=${item.id}`,
            full: true,
          });
          break;
        default:
          break;
      }
    },
    showLog (id) {
      this.$refs.logRightDialog.show(id);
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
